"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var js_brand_1 = require("@giphy/js-brand");
var react_1 = __importDefault(require("react"));
var Message = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    display: flex;\n    justify-content: center;\n    margin: 30px 0;\n    font-family: ", ";\n    font-size: 16px;\n    font-weight: 600;\n    a {\n        color: ", ";\n        cursor: pointer;\n        &:hover {\n            color: white;\n        }\n    }\n"], ["\n    color: ", ";\n    display: flex;\n    justify-content: center;\n    margin: 30px 0;\n    font-family: ", ";\n    font-size: 16px;\n    font-weight: 600;\n    a {\n        color: ", ";\n        cursor: pointer;\n        &:hover {\n            color: white;\n        }\n    }\n"])), js_brand_1.giphyLightGrey, js_brand_1.fontFamily.body, js_brand_1.giphyBlue);
var FetchError = function (_a) {
    var onClick = _a.onClick;
    return (react_1.default.createElement(Message, null,
        "Error loading GIFs.\u00A0",
        react_1.default.createElement("a", { onClick: onClick }, "Try again?")));
};
exports.default = FetchError;
var templateObject_1;
//# sourceMappingURL=fetch-error.js.map